import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import { useOnKeyPress } from "../../../../hooks/digitalMarketing/UseOnKeypress";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";

const MultiSelectCreate = (props) => {
  const { img, label, items, name, handleChange, onBlur, callBackforErrorMessage, openSnackBar,view } = props;
  const [ite, setitem] = useState<any>(items);
  
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [ms, setms] = useState<any>();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const CustomerDetail = useSelector((state: any) => state.customer.customerDetail);
  
 
   
 useEffect(() => {
  const value = props[name];

  if (value && value !== '') {
    let itemsArray: string[] = [];

    if (Array.isArray(value)) {
      // value is already an array
      itemsArray = value.map(item => String(item).trim());
    } else if (typeof value === 'string') {
      // value is a string, might be JSON or comma-separated
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          itemsArray = parsed.map(item => String(item).trim());
        } else {
          itemsArray = value.split(',').map(item => item.trim());
        }
      } catch {
        itemsArray = value.split(',').map(item => item.trim());
      }
    }

    setSelectedItems(
      itemsArray.map((item, index) => ({
        name: item,
        id: index + 1
      }))
    );
  }
}, [props, name]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if ( CustomerDetail.id ) {
      setAnchorEl(event.currentTarget);
    }
    else {
      // openSnackBar(callBackforErrorMessage(), "error")
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleItemClick = (item) => {
    let event = { target: { name: name, value: "" } }
    if (item) {
      const itemIndex = selectedItems.findIndex(
        (selectedItem) => selectedItem.name === item.name
      );
      if (itemIndex > -1) {
        setSelectedItems((prevItems) =>
          prevItems.filter((prevItem) => prevItem.name !== item.name));
        event.target.value = selectedItems.filter((prevItem) => prevItem.name !== item.name).map(item => item.name).join(',')
        handleChange(event)
        // onBlur(event);
      } else if (item.id === undefined) {
        if (ms !== '') {
          setSelectedItems((prevItems: any) => [
            ...prevItems,
            { id: ite.length + 1, name: ms },
          ]);
          event.target.value = [
            ...selectedItems,
            { id: ite.length + 1, name: ms },
          ].map(item => item.name).join(',')
          handleChange(event)
          // onBlur(event);
          setms("");
        }
      } else {
        setSelectedItems((prevItems: any) => [...prevItems, item]);
        event.target.value = [...selectedItems, item].map(item => item.name).join(',')
        handleChange(event)
      }
    }
    // handleChange(event)
  };
  useOnKeyPress(() => handleItemClick(ms), "Enter");

  const truncateLabel = (labelText, maxLength = 12) => {
    if (labelText.length > maxLength) {
      return `${labelText.substring(0, maxLength)}...`;
    }
    return labelText;
  };

  return (
    <div className="d-flex justify-content-between">
      <span className="det-label">
       {img && <img
          src={require(`../../../../assets/DigitalMarketing/image/customer/${img}.png`)}
          alt=""
        />}
       <Tooltip title={label} arrow>
          <span className="cursor-pointer">
            {truncateLabel(label)}
          </span>
        </Tooltip>
      </span>
      <input
        type="text"
        id="fade-button"
        value={selectedItems.length > 0 ? `${selectedItems.length} Selected` : ''}
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        placeholder="Empty"
        className="text-custom"
        readOnly
        disabled={view}
      />
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        style={{ padding: '10px' }}
      >
        <input
          type="text"
          value={ms}
          disabled={view}
          className="text-custom-tag"
          placeholder="Create one"
          onChange={(e) => setms(e.target.value)}
        />
        <ul className="tag-ul">
          <li><small>Select an option or create one</small></li>
          {items.map((item, i) => (
            <li key={i} onClick={() => handleItemClick(item)}>
              <img
                src={require("../../../../assets/DigitalMarketing/image/customer/tag.png")}
                width="8" alt=""
              />
              &nbsp;
              <span className={`tile-tag Thyroid cursor ${item?.name?.split(" ")[0]}`}>
                {item.name}
              </span>
              {selectedItems.some(
                (selectedItem: any) => selectedItem.name === item.name
              ) && <span className="cursor"> &#10006;</span>}
            </li>
          ))}
        </ul>
      </Menu>
      <div>
        {selectedItems.map((a, i) => (
          <span key={i} className={`tile-tag Thyroid ${a.name?.split(" ")[0]}`}>
            {a.name}
          </span>
        ))}
      </div>
    </div>
  );
};

export default React.memo(MultiSelectCreate);
